import { render, staticRenderFns } from "./RegistrationDialog.vue?vue&type=template&id=06c86c22"
import script from "./RegistrationDialog.vue?vue&type=script&lang=js"
export * from "./RegistrationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports